const createState = () => ({
  removedQueueIds: new Set(),
  deletedAppointmentIds: new Set(),
  extraAppointments: [],
  appointmentPatches: {},
  extraClients: [],
  extraExpensesByMonth: {},
  deletedExpenseIds: new Set(),
  reportedReviewIds: new Set(),
  nextId: -50000,
});

let state = createState();

export const resetDemoSession = () => {
  state = createState();
};

export const nextDemoId = () => {
  state.nextId -= 1;
  return state.nextId;
};

export const markQueueRemoved = (id) => {
  const n = Number(id);
  if (Number.isFinite(n)) state.removedQueueIds.add(n);
};

export const isQueueRemoved = (id) => state.removedQueueIds.has(Number(id));

export const markAppointmentDeleted = (id) => {
  const n = Number(id);
  if (Number.isFinite(n)) state.deletedAppointmentIds.add(n);
};

export const isAppointmentDeleted = (id) => state.deletedAppointmentIds.has(Number(id));

export const addDemoAppointment = (task) => {
  state.extraAppointments.push(task);
};

export const getExtraAppointments = () => state.extraAppointments;

export const patchDemoAppointment = (id, patch) => {
  const n = Number(id);
  if (!Number.isFinite(n) || !patch) return;
  state.appointmentPatches[n] = { ...(state.appointmentPatches[n] || {}), ...patch };
  state.extraAppointments = state.extraAppointments.map((task) =>
    Number(task.idprenotazione) === n ? { ...task, ...patch } : task,
  );
};

export const getAppointmentPatches = () => state.appointmentPatches;

export const addDemoClient = (client) => {
  state.extraClients.push(client);
};

export const getExtraClients = () => state.extraClients;

export const addDemoExpense = (month, expense) => {
  if (!state.extraExpensesByMonth[month]) state.extraExpensesByMonth[month] = [];
  state.extraExpensesByMonth[month].push(expense);
};

export const getExtraExpenses = (month) => state.extraExpensesByMonth[month] || [];

export const markExpenseDeleted = (id) => {
  const n = Number(id);
  if (Number.isFinite(n)) state.deletedExpenseIds.add(n);
};

export const isExpenseDeleted = (id) => state.deletedExpenseIds.has(Number(id));

export const markReviewReported = (id) => {
  if (id != null) state.reportedReviewIds.add(id);
};

export const isReviewReported = (id) => state.reportedReviewIds.has(id);
